export function formatDurationHours(
  value: number | string | null | undefined,
  fallback = "—",
) {
  if (value == null || value === "") return fallback;
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < 0) return fallback;

  const totalMinutes = Math.round(numeric * 60),
    hours = Math.floor(totalMinutes / 60),
    minutes = totalMinutes % 60;

  if (!hours) return `${minutes} min`;
  if (!minutes) return `${hours} h`;
  return `${hours} h ${String(minutes).padStart(2, "0")}`;
}
